import { ActionFunctionArgs, Outlet, redirect, useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { Breadcrumb } from "../../components/Breadcrumb";
import { createApolloClient } from "../../providers/ApolloClientFactory";
import { InvoiceItem } from "../invoices/type";
import { InvoiceItemList, invoiceItemsListLoader } from "./InvoiceItemList";
import { InvoiceItemCreate, invoiceItemCreateAction, invoiceItemCreateLoader } from "./InvoiceItemCreate";
import { InvoiceItemEdit, invoiceItemEditAction, invoiceItemEditLoader } from "./InvoiceItemEdit";
import { DELETE_INVOICE_ITEM } from "./mutations";

const client = createApolloClient();

const InvoiceItemsIndex = () => {
  const location = useLocation();
  const navigate = useNavigate();
  if (location.pathname === "/invoice-items") {
    navigate(`/invoice-items/list`);
  }
  return <Outlet />;
};

const invoiceItemDeleteAction = async ({ params }: ActionFunctionArgs) => {
  const { id } = params;
  try {
    await client.mutate({ mutation: DELETE_INVOICE_ITEM, variables: { id: Number(id) } });
    toast.success("Invoice item deleted");
    return redirect(`/invoice-items/list`);
  } catch (error) {
    toast.error("Failed to delete invoice item: " + error);
    return null;
  }
};

export const invoiceItemsRouter = {
  path: "/invoice-items",
  id: "invoice-items",
  element: <InvoiceItemsIndex />,
  handle: {
    crumb: () => <Breadcrumb name="Invoice Items" href="/invoice-items/list" />,
  },
  children: [
    {
      path: "list",
      id: "invoice-items-list",
      element: <InvoiceItemList />,
      loader: invoiceItemsListLoader,
    },
    {
      path: "create",
      id: "invoice-items-create",
      element: <InvoiceItemCreate />,
      loader: invoiceItemCreateLoader,
      action: invoiceItemCreateAction,
      handle: {
        crumb: () => <Breadcrumb name="Create Invoice Item" href="/invoice-items/create" />,
      },
    },
    {
      path: ":id/edit",
      id: "invoice-items-edit",
      element: <InvoiceItemEdit />,
      loader: invoiceItemEditLoader,
      action: invoiceItemEditAction,
      handle: {
        crumb: (data: { item: InvoiceItem }) => (
          <Breadcrumb name={`Edit ${data?.item?.name ?? "Invoice Item"}`} href={`/invoice-items/${data?.item?.id}/edit`} />
        ),
      },
    },
    {
      path: ":id/delete",
      id: "invoice-items-delete",
      action: invoiceItemDeleteAction,
    },
  ],
};
